var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-label-group',{class:[
    'phone-number-field',
    'mb-2',
    { 'phone-number-field--filled': _vm.hasValue, 'phone-number-field--focused': _vm.isFocused } ],attrs:{"label":_vm.calcLabel}},[_c('phone-number-input',{ref:"field",attrs:{"value":_vm.innerValue,"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required,"preferred-countries":_vm.preferredCountries,"default-country-code":_vm.defaultCountry,"no-use-browser-locale":!_vm.shouldDetectContry,"no-validator-state":"","no-example":""},on:{"phone-number-focused":_vm.onFocus,"phone-number-blur":_vm.onBlur,"input":_vm.onInput,"update":_vm.onUpdate}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b1703e4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/PhoneNumberField.vue
// module id = 1500
// module chunks = 1